import { useState } from "react";
import type { FC } from "react";
import Button from "react-bootstrap/Button";

import { BookmarkButton, Lightbox } from "components";
import { SolutionModal } from "features";

import type { TSolutionVariant, IAssignmentResult } from "store/slices/topicPractice";

import { getAssignmentModalPracticeByType } from "utils/getAssignmentByType";
import { getTextByAssignmentType } from "utils/formatTextForAnalysis";
import { getTextForSelfEvaluationOption } from "utils/getTextForSelfEvaluationOption";

interface Props {
  result: IAssignmentResult;
  onClose: () => void;
  isOpen: boolean;
}

const ResultModalPractice: FC<Props> = ({ result, onClose, isOpen }) => {
  const { assignment } = result.assignment;
  if (assignment === undefined || assignment === null) return null;

  const [questionAnalysisShown, setQuestionAnalysisShown] = useState<number | null>(null);

  const toggleModals = (questionAnalysisShown: number | null) => {
    setQuestionAnalysisShown(questionAnalysisShown);
  };

  const closeSolutionModal = () => {
    setQuestionAnalysisShown(null);
  };

  const getAnswerText = () => {
    if (questionAnalysisShown === null) return "";

    if (assignment.scoring?.scoringMethod.scoringMethod === "sebeopravení") {
      return getTextForSelfEvaluationOption(result.answerVariants[questionAnalysisShown ?? 0]);
    }

    const type = assignment.assignment?.assignmentType.type;
    if (typeof type !== "string") return "";

    return getTextByAssignmentType(type, result.userAnswers[questionAnalysisShown]);
  };

  const getAnswerType = (): TSolutionVariant => {
    const type = result.answerVariants[questionAnalysisShown ?? 0];

    return type ?? "danger";
  };

  return (
    <>
      <Lightbox
        show={isOpen && questionAnalysisShown === null}
        onHide={onClose}
        className={"modal--exercise"}
        size={"lg"}
        // Obsah se skládá dynamicky podle typu úlohy, žádný stabilní nadpis tu není —
        // jméno je proto neviditelné. Rozhodnuto se zadavatelem 31. 8. 2026. [TD-344]
        ariaLabel="Vyhodnocení úlohy"
        footerClassName={"modal-footer--yellow-bg"}
        footer={
          <div className="mw-sm">
            <div className="modal-footer-btn-stretch">
              <BookmarkButton userAssignmentId={result.assignment.id} />
              {/* TODO: translate */}
              <Button variant={"outline-secondary-darker"} onClick={onClose}>
                Zavřít
              </Button>
            </div>
          </div>
        }
      >
        <div className="exercise">
          <div className="exercise__body">
            {getAssignmentModalPracticeByType(assignment.assignment?.assignmentType.type, result, toggleModals)}
          </div>
        </div>
      </Lightbox>

      <SolutionModal
        isShown={isOpen && questionAnalysisShown !== null}
        assignment={assignment}
        questionIndex={questionAnalysisShown ?? 0}
        answerType={getAnswerType()}
        toggleModal={closeSolutionModal}
        isGoBackShown={true}
        userAssignmentId={result.assignment.id}
      >
        {getAnswerText()}
      </SolutionModal>
    </>
  );
};

export default ResultModalPractice;
